export const DEFAULT_PAGE_SIZE = 200;

export const DEFAULT_SORT_KEY = 'createdTimestamp';

export const DEFAULT_SORT_ORDER = 'desc';

export const DEFAULT_PAGINATION = {
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  totalCount: true,
  order: DEFAULT_SORT_ORDER,
  orderBy: DEFAULT_SORT_KEY,
};

export const DEFAULT_EDITOR_HEIGHT = '15rem';

export const VICE_CONTEXT = {
  TASK: 'task',
  PLAYBOOK_INSTANCE: 'playbook',
  NOTE: 'note',
  ACTIVITY: 'activity',
  TICKET: 'ticket',
};

export const DEFAULT_PLACEHOLDER_TXT = 'Post a comment';
